import React from 'react'
import styled from 'styled-components'

import { color } from 'styles/colors'
import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

type Props = {
  onGoBack?: () => void;
  className?: string;
};

const BUTTON_STYLES = {
  button: {
    height: 39,
    minWidth: 190,
    paddingRight: 8,
    paddingLeft: 8,
    borderRadius: 8
  }
}

export default function TicketSubmittedMessage ({ onGoBack, className }: Props) {
  return (
    <S.Wrapper className={className} role="status" aria-live="polite">
      <S.Card>
        <S.Illustration
          src="/img/mail-icon.svg"
          alt="Mail envelope icon indicating successful ticket submission"
        />
        <S.Heading>Support Ticket Created!</S.Heading>
        <S.Subheading>A support agent will contact you soon.</S.Subheading>
        {onGoBack && (
          <Button
            decoration="positive"
            text="Ok"
            onPress={onGoBack}
            styles={BUTTON_STYLES}
          />
        )}
      </S.Card>
    </S.Wrapper>
  )
}

const S = {
  Wrapper: styled.div`
    min-height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${color('primaryButtonText')};
    box-sizing: border-box;
  `,
  Card: styled.div`
    padding: 36px 28px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  `,
  Illustration: styled.img`
    width: 140px;
    height: 140px;
    object-fit: contain;
    margin: 18px 0;
    filter: none;
  `,
  Heading: styled.h2`
    margin: 6px 0 8px 0;
    font-size: 1rem;
    line-height: 1.1;
    color: ${color('primaryButton')};
    text-transform: unset;
    font-weight: bold;
  `,
  Subheading: styled.p`
    margin: 0 0 18px 0;
    color: ${color('primaryText')};
    font-size: 15px;
  `
}
